
export default {
  name: "itemsPagination",
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
